import { Link } from 'react-router-dom';

export default function SeoContent() {
  return (
    <section className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 font-label mb-4">
            About CSSBuy Sheet
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
            What Is a <span className="text-primary-500">CSSBuy Spreadsheet</span> and Why You Need One
          </h2>
          <div className="space-y-5 text-foreground-700 text-sm md:text-base leading-relaxed">
            <p>
              A <strong>CSSBuy spreadsheet</strong> is a meticulously curated product catalog that helps shoppers
              discover the finest replica items from verified and trusted sellers across multiple agent platforms.
              Instead of spending countless hours scrolling through fragmented forums, Discord channels, and
              Telegram groups, a well-maintained <strong>CSSBuy spreadsheet list</strong> consolidates
              everything you need — product links, QC (Quality Check) photos, pricing comparisons, sizing
              references, and seller reputation scores — into one organized, searchable document.
            </p>
            <p>
              This platform goes far beyond a single agent. We aggregate spreadsheet data from
              <strong> CSSBuy, Kakobuy, Superbuy, and Oopbuy</strong>, covering categories like sneakers,
              hoodies, t-shirts, jackets, pants, accessories, bags, and luxury goods. Each item entry
              includes verified QC data so you know exactly what you are getting before placing an order.
              Our <strong>CSSBuy spreadsheet 2026</strong> edition reflects the most current seller
              inventories, updated daily to remove dead links and add fresh finds.
            </p>
            <p>
              For those new to agent-based shopping, our platform also serves as a learning hub. Check
              out our detailed{' '}
              <Link
                to="/article/cssbuy-spreadsheet-2026-guide"
                className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
              >
                CSSBuy Spreadsheet 2026 Complete Guide
              </Link>
              , our{' '}
              <Link
                to="/article/kakobuy-vs-cssbuy-comparison"
                className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
              >
                Kakobuy vs CSSBuy Comparison
              </Link>
              , or our{' '}
              <Link
                to="/article/best-budget-finds-2026"
                className="text-primary-600 font-semibold hover:text-primary-700 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
              >
                Best Budget Finds 2026
              </Link>{' '}
              to learn how spreadsheet shopping works, what to look for in QC photos, how to compare
              prices across platforms, and which sellers consistently deliver the best quality. Whether
              you are a seasoned rep buyer or just getting started, a structured
              <strong> agent spreadsheet shopping list</strong> is the single most valuable tool
              you can have in your arsenal.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          <StatCard icon="ri-database-2-line" value="1,000+" label="Verified Items" />
          <StatCard icon="ri-user-star-line" value="50K+" label="Community Members" />
          <StatCard icon="ri-price-tag-3-line" value="99.2%" label="Link Accuracy" />
          <StatCard icon="ri-global-line" value="4" label="Agent Platforms" />
        </div>
      </div>
    </section>
  );
}

function StatCard({ icon, value, label }: { icon: string; value: string; label: string }) {
  return (
    <div className="text-center p-5 md:p-6 bg-background-50 rounded-2xl">
      <i className={`${icon} text-primary-500 text-2xl md:text-3xl`}></i>
      <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-3">{value}</p>
      <p className="text-foreground-500 text-xs md:text-sm mt-1">{label}</p>
    </div>
  );
}